// src/api/apiConfig.js
export const BASE_URL = 'https://api.gravity-proptech.com/public/api/website';
export const BASE_URL_IMG = 'https://api.gravity-proptech.com/public/storage';
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};
